module.exports = __webpack_public_path__ + "static/img/16039C_3_R_20200712_fit.c20884c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16039C_3_R_20200712_fit.png
// module id = Osgx
// module chunks = 0